import type { CSSProperties, ReactNode } from "react"

// Ícones de traço da página de referência (todos decorativos).
type IconProps = { size?: number; strokeWidth?: number; className?: string; style?: CSSProperties }

function Stroke({ size = 18, strokeWidth = 2.2, className, style, children }: IconProps & { children: ReactNode }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      {children}
    </svg>
  )
}

export const ArrowRight = (p: IconProps) => (
  <Stroke {...p}>
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </Stroke>
)

export const ArrowUpRight = (p: IconProps) => (
  <Stroke {...p}>
    <path d="M7 17L17 7" />
    <path d="M8 7h9v9" />
  </Stroke>
)

export const Check = (p: IconProps) => (
  <Stroke strokeWidth={2.6} {...p}>
    <path d="M5 12.5l4 4 10-10" />
  </Stroke>
)

export const ArrowUp = (p: IconProps) => (
  <Stroke strokeWidth={2.4} {...p}>
    <path d="M12 19V5" />
    <path d="M6 11l6-6 6 6" />
  </Stroke>
)

export const Lock = (p: IconProps) => (
  <Stroke {...p}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </Stroke>
)

export const Menu = (p: IconProps) => (
  <Stroke strokeWidth={2} {...p}>
    <path d="M4 7h16" />
    <path d="M4 12h16" />
    <path d="M4 17h16" />
  </Stroke>
)

export const Close = (p: IconProps) => (
  <Stroke strokeWidth={2} {...p}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </Stroke>
)
